'use strict';

/**
*        
*   ---=== FlexTools ===---
*   https://zhangfisher.github.com/flex-tools
* 
*   一些实用工具函数
*
*/
function t(n){return n!=null&&typeof n[Symbol.iterator]=="function"&&typeof n!="string"}

exports.a = t;
